
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-time-to-arrive/[hour]",
      function () {
        return require("private-next-pages/best-time-to-arrive/[hour].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-time-to-arrive/[hour]"])
      });
    }
  